import * as React from 'react'
import { debounce } from 'throttle-debounce'

import { cn } from '~/styled'

import { Label } from '../label/Label'
import { SearchInput } from '../search-input/SearchInput'
import { AsyncDataState } from './DataTable.types'
import { useDataTable } from './DataTableContext'

type DataTableSearchProps = React.ComponentProps<typeof SearchInput> & {
  label: string
  hideLabel?: boolean
}
export const DataTableGlobalFilter = ({
  onChange,
  label,
  hideLabel = false,
  ...props
}: DataTableSearchProps) => {
  const {
    setGlobalFilter,
    getState,
    resetPagination,
    getTotalRows,
    asyncDataState
  } = useDataTable()
  const { globalFilter } = getState()

  const isPending = asyncDataState === AsyncDataState.PENDING
  const isEmpty = !isPending && getTotalRows() === 0

  if (isEmpty) return null

  const handleChange = debounce(250, (event) => {
    const {
      target: { value }
    } = event

    onChange?.(event)
    resetPagination()
    setGlobalFilter(value)
  })

  return (
    <>
      <Label htmlFor={label} className={cn('mb-3', hideLabel && 'sr-only')}>
        {label}
      </Label>
      <SearchInput
        {...props}
        defaultValue={globalFilter}
        onChange={handleChange}
        name={label}
      />
    </>
  )
}
